import IconDashboard from "@mui/icons-material/Dashboard";

import HomeIcon from "@mui/icons-material/Home";
import FreeBreakfastIcon from "@mui/icons-material/FreeBreakfast";
import TextFormatIcon from "@mui/icons-material/TextFormat";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import FormatListNumberedRtlIcon from "@mui/icons-material/FormatListNumberedRtl";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PhotoIcon from "@mui/icons-material/Photo";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import EmojiObjectsIcon from "@mui/icons-material/EmojiObjects";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import DescriptionIcon from "@mui/icons-material/Description";

const appMenuItems = [
  {
    name: "Home",
    id: "home",
    Icon: HomeIcon,
  },
  {
    name: "CoffeeWithMe",
    id: "contact",
    Icon: FreeBreakfastIcon,
  },
  {
    name: "Articles",
    id: "articles",
    Icon: TextFormatIcon,
  },
  {
    name: "Resume Builder",
    id: "create-resume",
    route: "/create-resume",
    Icon: DescriptionIcon,
  },

  {
    name: "UPI Expense Calculator",
    id: "upi-expense-cal",
    route: "/upi-expense-cal",
    Icon: CurrencyRupeeIcon,
  },

  {
    name: "Youtube",
    id: "youtube",
    Icon: YouTubeIcon,
  },
  {
    name: "Gallery",
    id: "gallery",
    Icon: PhotoIcon,
  },

  {
    name: "Chef-Corner",
    id: "chefcorner",
    Icon: FastfoodIcon,
  },
  {
    name: "View My Resume",
    id: "resume",
    route: "/resume",
    Icon: LibraryBooksIcon,
  },

  {
    name: "Tools",
    // Icon: ExpandMoreIcon,
    id: "tools",
    items: [
      {
        name: "Resume Builder",
        id: "create-resume",
        route: "/create-resume",
        Icon: DescriptionIcon,
      },
      {
        name: "UPI Expense Calculator",
        id: "upi-expense-cal",
        route: "/upi-expense-cal",
        Icon: CurrencyRupeeIcon,
      },
      {
        name: "Age Calculator",
        id: "age-calculator",
        route: "/age-calculator",
        Icon: EscalatorWarningIcon,
      },
    ],
  },

  {
    name: "More",
    // Icon: ExpandMoreIcon,
    id: "more",
    items: [
      {
        name: "BooksIRead",
        id: "books",
        Icon: LibraryBooksIcon,
      },
      {
        name: "My Fav Quotes",
        id: "favquotes",
        Icon: FormatQuoteIcon,
      },
      {
        name: "My Thoughts",
        id: "mythoughts",
        Icon: EmojiObjectsIcon,
      },
      {
        name: "Projects",
        id: "projects",
        Icon: IconDashboard,
      },
      {
        name: "Skills",
        id: "skills",
        Icon: FormatListNumberedRtlIcon,
      },
    ],
  },
];

export default appMenuItems;
